import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@mui/material';

/**
 * Dialog for moving a folder to a different parent.
 */
const MoveFolderDialog = ({
                              open,
                              folderId,
                              currentTarget,
                              moveOptions,
                              onTargetChange,
                              onClose,
                              onConfirm,
                          }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Move folder</DialogTitle>
            <DialogContent sx={{minWidth: 360}}>
                <FormControl sx={{width: '100%', mt: 1}}>
                    <InputLabel id={`move-target-label-${folderId}`}>Destination</InputLabel>
                    <Select
                        labelId={`move-target-label-${folderId}`}
                        value={currentTarget}
                        label="Destination"
                        variant="outlined"
                        onChange={(e) => onTargetChange(e.target.value)}
                    >
                        {moveOptions.map((opt) => (
                            <MenuItem key={opt.id || '__root'} value={opt.id}>
                                {opt.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={onConfirm} variant="contained">Move</Button>
            </DialogActions>
        </Dialog>
    );
};

export default MoveFolderDialog;
